import React from 'react';

const GSV = () => {
  return (
    <svg
      width="685"
      height="497"
      viewBox="0 0 685 497"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="285.5" cy="146.5" r="56" stroke="black" strokeWidth="23" />
      <rect
        x="12.5"
        y="12.5"
        width="660"
        height="472"
        rx="28.5"
        stroke="black"
        strokeWidth="25"
      />
      <path
        d="M13 316L126.663 218.694C138.981 208.149 157.344 208.878 168.787 220.366L275.5 327.5M275.5 327.5L124 482M275.5 327.5L467.765 137.481C479.819 125.568 499.206 125.542 511.29 137.424L668 291.5"
        stroke="black"
        strokeWidth="24"
      />
    </svg>
  );
};

export default GSV;
